import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { AppWrapper, MotionWrapper } from '../../HOC';
import { urlFor, client } from '../../client';
import './services.scss';

const Services = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [services, setServices] = useState([]);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const query = '*[_type == "services"]';

    client.fetch(query).then((data) => {
      setServices(data);
    });

  }, []);

  return (
    <>
      <div className="app__services-header">
        <h2 className="head-text">Services</h2>
        <h3 className="sub-title">What I Offer</h3>
      </div>
      {services.length && (
        <>
          <div className="app__service-item app__flex">
            <div>
                <h4 className="bold-text">{services[currentIndex].name}</h4>
                <h5 className="p-text">Current Stack: {services[currentIndex].stack}</h5>
            </div>
            <img src={urlFor(services[currentIndex].icon)} alt={services[currentIndex].name} />
            <div className="app__service-content">
              <p className="p-text">{services[currentIndex].description}</p>
            </div>
          </div>

          <div className="app__service-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? services.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>

            <div className="app__flex" onClick={() => handleClick(currentIndex === services.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AppWrapper(
  MotionWrapper(Services, 'app__services'),
  'services',
  'app__primarybg',
);